import { Component, Input, ViewChild } from '@angular/core';
import { IconHover, StorageName } from '../../../enum/common-enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../../services/storage.service';
import { CustomSelect2Component } from '../../custom-select2/custom-select2.component';

@Component({
  selector: 'app-product-dropdown-popup',
  templateUrl: './product-dropdown-popup.component.html',
  styleUrls: ['./product-dropdown-popup.component.scss']
})
export class ProductDropdownPopupComponent {
  @ViewChild(CustomSelect2Component) customSelect2Component: CustomSelect2Component;
  @Input() data: any;
  currentHoverEffect = IconHover.Pink;
  storageName = StorageName;
  currentProductId: string = '';  
  productDetailId: string;

  constructor(
    public activeModal: NgbActiveModal,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.currentProductId = this.data?.currentProductId || '';
  }

  ngAfterViewInit(): void {
    this.fillDropdownData();
  }

  fillDropdownData(): void {
    const productDropdown = this.storageService.retrieve(this.storageName.PRODUCT_DROPDOWN)?.filter(x => x.extra1 == this.data?.tabId) || [];
      this.customSelect2Component?.setDataSource(productDropdown);
    if (this.currentProductId) {
      setTimeout(() => {
        this.customSelect2Component?.setDataSource(productDropdown, String(this.currentProductId));
      }, 100);
    }
  }

  assignAccountProductId(id: string): void {
    this.productDetailId = id;
    this.activeModal?.close(this.productDetailId);
  }
}

